import React, {FC} from 'react'

import TemplateThumbnail1 from 'assets/templates/1.svg'
import TemplateThumbnail2 from 'assets/templates/2.svg'
import TemplateThumbnail3 from 'assets/templates/3.svg'
import TemplateThumbnail4 from 'assets/templates/4.svg'
import TemplateThumbnail5 from 'assets/templates/5.svg'
import TemplateThumbnail6 from 'assets/templates/6.svg'

type TReactSVGComponent = React.FunctionComponent<React.SVGProps<SVGSVGElement>>

type TIconProps = {
	number: number
	className: string
}

type TIconType = {
	[number: number]: TReactSVGComponent
}

const iconTypes: TIconType = {
	1: TemplateThumbnail1,
	2: TemplateThumbnail2,
	3: TemplateThumbnail3,
	4: TemplateThumbnail4,
	5: TemplateThumbnail5,
	6: TemplateThumbnail6,
}

export const TemplateThumbnailIcon: FC<TIconProps> = ({number, className}) => {
	const Icon = iconTypes[number]

	return <Icon className={className} />
}
